import { styled, Typography } from '@mui/material';
import BulletPointsList from 'components/BulletPointsList';

export const StyledDiv = styled('div')`
  margin-bottom: 60px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const StyledText = styled(Typography)`
  margin-top: 1rem;
`;

export const StyledBulletPointsList = styled(BulletPointsList)`
  padding: 0;
`;
